const fr = {
    language: {
        label: 'Langue',
        heading: 'Langue d’affichage',
        help: 'Choisissez la langue des menus, boutons, libellés, Aide et en-têtes de rapports dans BistroAdmin. Cela s’applique uniquement à ce navigateur et ne change pas le POS, l’application Paie, les messages clients, le format monétaire ni les heures du commerçant.',
        posHeading: 'Langue d’affichage du POS',
        posHelp: 'Cette langue est utilisée sur tous les terminaux POS de ce magasin. Elle est distincte de la langue BistroAdmin ci-dessus. Si elle n’est pas définie ou n’est pas reconnue, l’anglais est utilisé. La modifier ne bloque pas la connexion, le pointage ni les ventes.',
        posLabel: 'Langue du POS',
        posSave: 'Enregistrer la langue du POS',
    },
    common: {
        cancel: 'Annuler',
        save: 'Enregistrer',
        saving: 'Enregistrement…',
        refresh: 'Actualiser les données',
        loading: 'Chargement…',
        add: 'Ajouter',
        edit: 'Modifier',
        delete: 'Supprimer',
        open: 'Ouvrir',
        yes: 'Oui',
        no: 'Non',
        confirm: 'Êtes-vous sûr ?',
        name: 'Nom',
        status: 'Statut',
        actions: 'Actions',
        action: 'Action',
        image: 'Image',
        active: 'Actif',
        archived: 'Archivé',
        default: 'Par défaut',
        connected: 'Connecté',
        notConnected: 'Non connecté',
        required: 'Obligatoire',
        optional: 'Facultatif',
        update: 'Mettre à jour',
    },
    nav: {
        products: 'Produits',
        workPeriods: 'Périodes de travail',
        users: 'Utilisateurs',
        settings: 'Paramètres',
        help: 'Aide',
        logOut: 'Déconnexion',
        toggle: 'Afficher ou masquer la navigation',
        logoAlt: 'Bistro Admin',
    },
    header: {
        refreshToast: 'Actualisation des données...',
        merchantUnavailable: 'Les informations du commerçant sont indisponibles.',
    },
    login: {
        title: 'Connectez-vous à votre compte',
        username: 'Nom d’utilisateur',
        usernamePlaceholder: 'Saisissez le nom d’utilisateur',
        password: 'Mot de passe',
        passwordPlaceholder: 'Saisissez le mot de passe',
        submit: 'Connexion',
        submitting: 'Connexion…',
        logoAlt: 'Bistro Admin',
    },
    settingsTabs: {
        store: 'Magasin',
        stations: 'Stations',
        customerScreen: 'Écran client',
        layouts: 'Plans',
        integrations: 'Intégrations',
        system: 'Système',
        payroll: 'Paie',
        payout: 'Paiements',
    },
    productsTabs: {
        categories: 'Catégories',
        products: 'Produits',
        menus: 'Menus',
        export: 'Exporter',
        import: 'Importer',
        exportTitle: 'Exporter tous les produits et catégories',
        importTitle: 'Importer des produits et catégories depuis un fichier',
        merchantUnavailable: 'Les informations du commerçant sont indisponibles. Actualisez la page ou reconnectez-vous.',
        exportFormat: 'Format d’export',
        exportChoose: 'Choisissez un format pour exporter vos produits et catégories :',
        importFormat: 'Format d’import',
        importChoose: 'Choisissez le format du fichier à importer :',
        excel: 'Excel (.xlsx)',
        json: 'JSON (.json)',
        confirmImport: 'Confirmer l’import',
        aboutToImport: 'Vous allez importer :',
        categoriesCount: '{count} catégories',
        productsCount: '{count} produits',
        variationsCount: '{count} variantes',
        optionsCount: '{count} options',
        importNote: 'Les catégories déjà existantes seront ignorées. Les produits seront créés comme de nouveaux articles.',
        exportedOn: 'Exporté le : {date}',
        importing: 'Import des produits...',
        categoriesTitle: 'Catégories',
        categoryName: 'Nom de catégorie',
        items: 'Articles',
        printer: 'Imprimante',
        addCategory: 'Ajouter une catégorie',
        editCategory: 'Modifier la catégorie',
        changeImage: 'Changer',
        addIcon: 'Ajouter une icône',
        productsTitle: 'Produits',
        product: 'Produit',
        category: 'Catégorie',
        variationsShort: 'Var.',
        priceUsd: 'Prix($)',
        inStock: 'En stock',
        sku: 'SKU',
        menusTitle: 'Menus',
        menusIntro: 'Les menus nommés filtrent le catalogue POS. L’import/export n’inclut pas les menus. Défaut pour toutes les stations : {default} (les stations peuvent le remplacer dans Paramètres → Stations).',
        menusIntroSchedule: ' Ouvrez un menu pour modifier ses plages horaires.',
        showArchived: 'Afficher les archivés',
        autoScheduleOn: 'Planification auto activée',
        useAutoSchedule: 'Utiliser la planification auto',
        autoScheduleTitle: 'Activer la planification auto. Les plages correspondantes remplacent le défaut. Sans plage, le POS utilise le menu par défaut (ou Tous s’il n’y en a pas). Cliquez à nouveau pour désactiver.',
        autoScheduleOnTitle: 'Désactiver la planification auto. Le menu par défaut sélectionné est conservé.',
        autoScheduleWithFallback: 'Planification auto (sans plage : {default})',
        clearDefault: 'Effacer le défaut (Tous)',
        addMenu: 'Ajouter un menu',
        noMenus: 'Aucun menu pour l’instant. Créez Petit-déjeuner / Déjeuner / Dîner pour filtrer le catalogue POS. En attendant, le POS affiche le catalogue complet.',
        menuNameRequired: 'Le nom du menu est obligatoire.',
        order: 'Ordre',
        autoSchedule: 'Planification auto',
        allFullCatalog: 'Tous (catalogue complet)',
        editMenu: 'Modifier le menu',
        sortOrder: 'Ordre de tri',
        moveUp: 'Monter',
        moveDown: 'Descendre',
        setDefault: 'Définir par défaut',
        setDefaultTitle: 'Les stations sans exception chargent ce menu. Avec Auto activé, il sert aussi lorsqu’aucune plage ne correspond.',
        archive: 'Archiver',
        restore: 'Restaurer',
        internal: 'Interne',
        fromCategory: 'Depuis la catégorie',
    },
    usersChrome: {
        people: 'Personnes',
        name: 'Nom',
        phone: 'Téléphone',
        email: 'E-mail',
        roleType: 'Type de rôle',
        role: 'Rôle',
        stripeTips: 'Paiements de pourboires Stripe',
        addPeople: 'Ajouter une personne',
        editPeople: 'Modifier la personne',
        id: 'ID',
        phoneShort: 'Tél.',
        created: 'Créé',
        tips: 'Pourboires',
        pin: 'Code PIN à 4 chiffres',
        pinHelp: '4 chiffres, ne peut pas commencer par 0',
        pinPlaceholder: 'ex. 1234',
        payroll: 'Paie',
        receivesHourlyWage: 'Reçoit un salaire horaire',
        hourlyRate: 'Taux horaire',
        hourlyRequired: 'Obligatoire lorsque le salaire horaire est activé.',
        nonHourlyHelp: 'Le personnel non horaire est exclu de la synchro des heures de salaire.',
        tipsInPayroll: 'Pourboires et gratifications dans la paie',
        inheritDefault: 'Utiliser la valeur par défaut du commerçant',
        alwaysInclude: 'Toujours inclure (pourboires et gratifications impayés)',
        neverInclude: 'Ne jamais inclure',
        merchantDefaultHelp: 'La valeur par défaut du commerçant se définit dans Paramètres → Paie.',
        stripeDisabled: 'Les paiements de pourboires sont désactivés dans les paramètres du magasin. Aucun lien de configuration Stripe n’est disponible pour ce magasin.',
        stripeAfterCreate: 'Après création de cet utilisateur, vous pouvez envoyer un lien d’inscription Stripe ou lier un compte Stripe existant.',
    },
    workperiods: {
        end: 'Terminer la période de travail',
        ending: 'Fin…',
        start: 'Démarrer la période de travail',
        starting: 'Démarrage…',
        period: 'Période',
        trans: 'Trans.',
        charges: '*NET',
        net: 'NET CARTE',
        fees: 'Frais',
        adminFees: 'Frais admin',
        items: 'Articles',
        card: 'Carte',
        cash: 'Espèces',
        tipsCard: 'Pourboires (carte)',
        tipOuts: 'Sorties de pourboire',
        ref: 'Réf.',
        netSalesMerch: 'Ventes après remboursements',
        tax: 'Taxe',
        grat: 'Grat.',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        active: 'Actif',
        search: 'Rechercher',
        searchPlaceholder: 'Période (ex. lun) ou montant...',
    },
    payroll: {
        heading: 'Paie',
        intro: 'Configurez comment ce commerçant prépare le personnel pour la paie. Le salaire horaire et les exceptions de pourboire par employé se règlent dans Utilisateurs. Finaliser un cycle dans Rebelity Payroll peut marquer les pourboires impayés comme payés (sans virement Stripe). Si Check payroll est activé, les pourboires impayés ne sont marqués payés qu’après succès de l’ACH salarial Check.',
        loading: 'Chargement des paramètres de paie…',
        enable: 'Activer la paie pour ce commerçant',
        includeTips: 'Inclure pourboires et gratification dans la paie (défaut commerçant)',
        engine: 'Moteur de paie',
        engineFallback: 'Saisissez l’URL de base privée du moteur de paie, puis enregistrez.',
        baseUrl: 'URL de base du moteur de paie',
        apiKey: 'Clé API (facultatif)',
        keySaved: 'Clé enregistrée — laissez vide pour la conserver',
        engineHelp: 'Le navigateur n’appelle jamais le moteur de paie. POSApi utilise cette URL pour synchroniser heures/pourboires et tables fiscales. Utilisez un hôte joignable par le serveur API (pas le localhost de votre portable sur EB partagé).',
        connecting: 'Connexion…',
        saveTest: 'Enregistrer et tester la connexion',
        openPayroll: 'Ouvrir la paie',
        save: 'Enregistrer les paramètres de paie',
        checkPayroll: 'Paie Check',
        loadingCheck: 'Chargement du statut Check…',
        manageIntegrations: 'Gérer dans Intégrations',
        integrations: 'Intégrations',
        payrollStates: 'États de paie',
        taxHeading: 'Stripe Tax (taxe de vente) · Phase 5a',
        taxIntro: 'Taxe de vente à la charge du commerçant via Stripe Tax pour plateformes (valeurs pilotes Atlanta / GA). Distinct des cotisations de paie. Enregistrez les sites dans le tableau de bord Stripe du compte connecté.',
        saveTax: 'Enregistrer les paramètres Stripe Tax',
        recording: 'Enregistrement…',
        recordRemit: 'Enregistrer le versement',
        offlineTaxMode: 'Mode taxe hors ligne / espèces (T2)',
        taxApiDefault: 'API fiscale + transactions (défaut)',
        stripeChannelsOnly: 'Canaux Stripe uniquement (pas de transactions fiscales espèces)',
    },
    report: {
        employeeSalesTitle: 'Rapport des ventes employé',
        workPeriodTitle: 'Rapport des ventes de la période de travail',
        workPeriodDetail: 'Détail de la période de travail',
        employee: 'Employé',
        store: 'Magasin',
        period: 'Période',
        generated: 'Généré',
        summary: 'Résumé',
        value: 'Valeur',
        shifts: 'Services',
        hours: 'Heures',
        totalSales: 'Ventes totales',
        tips: 'Pourboires',
        gratuity: 'Gratification',
        earnings: 'Gains',
        cash: 'Espèces',
        card: 'Carte',
        member: 'Membre',
        fees: 'Frais',
        tipsOwed: 'Pourboires dus',
        tipsPaid: 'Pourboires versés',
        totalTipsAndGrat: 'Total pourboires et grat.',
        yourShare: 'Votre part',
        pooledWorkPeriods: 'Périodes avec pourboires mis en commun',
        saleTimeWorkPeriods: 'Périodes sans pourboires mis en commun',
        totalTipsGratExplainer: 'Total pourboires et grat. est le total des pourboires et de la gratification de la période de travail pour tous les employés.',
        payoutExplainer: 'Si vous n\'avez pas connecté votre compte bancaire à notre système via Stripe, vous ne pouvez pas être payé directement. À la place, nos pourboires seront envoyés au responsable de service désigné, qui devra vous payer. Tous les versements du week-end sont disponibles le mercredi ou le jeudi suivant.',
        overview: 'Aperçu',
        salesBreakdown: 'Répartition des ventes',
        tipPayouts: 'Versement des pourboires',
        summaryFor: 'Résumé pour {range}',
        noShiftsIn: 'Aucun service pour {range}',
        date: 'Date',
        status: 'Statut',
        clockIn: 'Entrée',
        clockOut: 'Sortie',
        field: 'Champ',
        time: 'Temps',
        sales: 'Ventes',
        tipsEarnings: 'Pourboires et gains',
        payoutStatus: 'Statut de paiement',
        totalHours: 'Heures totales',
        cashSales: 'Ventes espèces',
        cardSales: 'Ventes carte',
        memberSales: 'Ventes membre',
        totalEarnings: 'Gains totaux',
        shift: 'Service',
        sheetSummary: 'Résumé',
        sheetWorkPeriods: 'Périodes de travail',
        none: 'Aucun',
        stillActive: 'Toujours actif',
        employeeSalesHeading: 'Ventes de {name}',
        employeeSalesSubtitle: 'Voir les ventes, pourboires et heures de travail',
        export: 'Exporter',
        exporting: 'Export…',
        exportTitle: 'Exporter le rapport filtré',
        emailPdf: 'Envoyer le PDF à {email}',
        noEmail: 'Aucun e-mail enregistré',
        textPdf: 'Envoyer le lien PDF à {phone}',
        noPhone: 'Aucun téléphone enregistré',
        pdf: 'PDF (.pdf)',
        csv: 'CSV (.csv)',
        excel: 'Excel (.xlsx)',
        paid: 'Payé',
        pending: 'En attente',
        transferId: 'ID de transfert',
        hrs: 'h',
        afterRefunds: 'Après remboursements',
        salesBeforeRefunds: 'Ventes avant remboursements',
        salesAfterRefunds: 'Ventes après remboursements',
        discounts: 'Remises',
        comps: 'Offerts',
        merchRefunds: 'Remboursements marchandises',
        merchRefundsHelp: 'Les remboursements marchandises sont le coût article uniquement (nourriture et boisson retournées). Ils n’incluent pas la taxe, les frais, les pourboires ni la gratification.',
        netSalesMerch: 'Ventes après remboursements',
        customerRefunds: 'Remboursements client (charge)',
        customerRefundsHelp: 'Les remboursements client sont la charge complète rendue au client — marchandises plus toute taxe, frais, pourboires, gratification ou montants similaires annulés.',
        taxCollected: 'Taxe collectée',
        taxRefunded: 'Taxe remboursée',
        taxNet: 'Taxe nette',
        taxNetHelp: 'Taxe nette = taxe collectée − taxe remboursée. La taxe n’est pas incluse dans Ventes avant remboursements ni Ventes après remboursements.',
        netTips: 'Pourboires nets',
        netGratuity: 'Gratification nette',
        refundNetFootnote: 'Ventes après remboursements = ventes avant remboursements − remboursements marchandises. Les remboursements de charge client (taxe, pourboire, frais) sont listés séparément et ne sont pas retranchés une seconde fois des ventes après remboursements.',
        refundEstimateFootnote: 'Certains remboursements étaient un montant seul (sans quantités d’articles). Les parts marchandises et pourboire/gratification sont estimées — vérifiez le reçu de remboursement POS si besoin.',
    },
    store: {
        details: 'Détails du magasin',
        wpStart: 'Heure de début de période',
        wpEnd: 'Heure de fin de période',
        wpEndHelp: 'Si défini, les périodes ouvertes se terminent à cette heure locale du magasin. Le personnel POS reçoit des alertes 15/5/1 minutes avec son ; la clôture auto attend que tous les comptes soient fermés.',
        name: 'Nom du magasin',
        type: 'Type de magasin',
        email: 'E-mail',
        phone: 'Tél.',
        address: 'Adresse',
        useAccountDefault: 'Utiliser la valeur par défaut du compte',
        street: 'Rue',
        city: 'Ville',
        state: 'État',
        zip: 'Code postal',
        description: 'Description du magasin',
        descriptionPlaceholder: 'Saisissez une brève description de votre magasin',
        receiptFooter: 'Texte de pied de ticket',
        receiptFooterHelp: 'Ce texte apparaîtra en bas des tickets imprimés',
        tipPayoutRouting: 'Routage des paiements de pourboires',
        tipModeMerchant: 'Les pourboires vont au commerçant — les employés sont payés autrement',
        tipModeDisabled: 'Les paiements de pourboires sont désactivés — aucun lien ni transfert Stripe employé ne sera utilisé',
        tipModePlatform: 'Pourboires retenus sur la plateforme — transférés automatiquement aux employés via Stripe',
        tipRoutingMode: 'Mode de routage des pourboires',
        optionPlatform: 'Plateforme (transfert auto vers les employés)',
        optionMerchant: 'Compte commerçant (le commerçant paie les employés)',
        optionDisable: 'Désactiver les paiements de pourboires',
        saveDetails: 'Enregistrer les détails du magasin',
        image: 'Image du magasin',
        imageDefault: '*Par défaut, image du compte client si non spécifiée',
        change: 'Modifier',
        addImage: 'Ajouter une image',
        saveImage: 'Enregistrer l’image du magasin',
        storeAlt: 'Magasin',
    },
    stations: {
        heading: 'Station :',
        intro: 'Créez des stations à attribuer aux terminaux',
        name: 'Nom de la station',
        namePlaceholder: 'Station serveur',
        terminal: 'Terminal',
        unassigned: 'Non attribué',
        save: 'Enregistrer la station',
        note: 'Note :',
        noteBody: 'Les terminaux ne peuvent être attribués aux stations que dans BistroPOS. Une fois une station créée ici, attribuez un terminal via le menu Paramètres puis l’onglet Terminaux de l’application Bistro.',
        available: 'Stations disponibles',
        menu: 'Menu',
        deleteConfirm: 'Supprimer la station ?',
        editName: 'Modifier le nom de la station',
        inherit: 'Hériter de la valeur par défaut du commerçant',
        autoSchedule: 'Programmation auto',
        allCatalog: 'Tout (catalogue complet)',
        menuHelp: 'Les substitutions s’appliquent sur Bistro / kiosque pour cette station. Les caissiers peuvent changer de menu jusqu’à la déconnexion. Auto utilise les plages horaires de chaque menu (heure locale du commerçant).',
        layout: 'Plan',
        layoutHelp: 'Quand le mode plan est activé, cette station ouvre le plan de salle choisi. Tout plan actif du lieu du compte peut être sélectionné.',
    },
    excel: {
        sheetCategories: 'Catégories',
        sheetProducts: 'Produits',
        name: 'Nom',
        printerId: 'PrinterId',
        picture: 'Image',
        internalOnly: 'InterneUniquement',
        categoryName: 'NomCategorie',
        description: 'Description',
        sku: 'SKU',
        barcode: 'Code-barres',
        price: 'Prix',
        feeOption: 'OptionFrais',
        taxRate: 'TauxTaxe',
        inventory: 'Inventaire',
        variations: 'Variantes',
        options: 'Options',
        missingCategories: 'Feuille « Categories » ou « Catégories » manquante',
        missingProducts: 'Feuille « Products » ou « Produits » manquante',
    },
    system: {
        loadFailed: 'Impossible de charger les paramètres système.',
        notificationLoadFailed: 'Impossible de charger les paramètres de notification client.',
        loadingSettings: 'Chargement des paramètres système…',
        loadingNotifications: 'Chargement des notifications par défaut…',
        deliveryHeading: 'Envoi automatique du rapport de service',
        deliveryIntro: 'Lorsqu’il est activé, les employés reçoivent automatiquement le rapport de ventes de la période de travail à la sortie de service sur le POS, ou lorsqu’une période terminée les sort automatiquement. Les envois manuels depuis Ventes employés restent inchangés.',
        smsToggle: 'Envoyer le rapport de service par SMS à la sortie',
        smsHelp: 'Envoie un lien PDF par SMS lorsque l’employé a un numéro de téléphone enregistré.',
        emailToggle: 'Envoyer le rapport de service par e-mail à la sortie',
        emailHelp: 'Envoie un lien PDF par e-mail lorsque l’employé a une adresse e-mail enregistrée.',
        deliveryNotConfigured: 'L’envoi {channel} n’est pas configuré dans cet environnement. Vous pouvez enregistrer l’option, mais les rapports ne partiront pas tant que l’envoi n’est pas configuré.',
        saveDelivery: 'Enregistrer l’envoi des rapports',
        pooledHeading: 'Pourboires mis en commun',
        pooledIntro: 'Lorsqu’il est activé, les pourboires et la gratification sont partagés par session d’horloge (voir le rapport de pourboires mis en commun) et Stripe verse des parts égales à la fin de la période de travail, ou via Payer les pourboires mis en commun sur le détail d’une période terminée. Les virements par employé au moment de la vente sont suspendus tant que cette option est active. Nécessite le mode de routage des pourboires = frais d’application de la plateforme. Désactivez seulement après paiement des périodes non réglées. Le résumé de clôture reste inchangé.',
        pooledToggle: 'Pourboires mis en commun',
        pooledHelp: 'Les pourboires et la gratification sont partagés entre les employés ayant le rôle User qui étaient pointés lors de chaque vente. Les codes Admin ou Manager seuls ne reçoivent pas de part, même s’ils pointent ou encaissent la vente. Un code qui a aussi le rôle User reste dans le pot. Si aucun employé User n’était pointé, le pourboire reste sur la plateforme. La sortie de service fige la part de cette personne. Le règlement s’effectue à la fin de la période ; utilisez Payer les pourboires mis en commun sur les périodes terminées pour réessayer. Les pourboires déjà versés au moment de la vente (avant l’activation de la mise en commun) sont exclus du pot.',
        savePooled: 'Enregistrer les pourboires mis en commun',
        payoutSmsHeading: 'SMS de versement des pourboires',
        payoutSmsIntro: 'Lorsqu’il est activé, l’employé reçoit un seul SMS lorsqu’un versement arrive sur son propre compte Stripe. Les pourboires en temps réel n’envoient pas un SMS à chaque vente.',
        payoutSmsToggle: 'Envoyer un SMS à l’employé lorsque le versement arrive sur son compte Stripe',
        payoutSmsHelp: 'Le SMS utilise la langue POS du magasin. Il indique le montant versé sur Stripe et qu’il devrait arriver sur le compte bancaire sous 2 jours ouvrables. Il n’est pas envoyé lorsque le versement va au responsable désigné, ni une seconde fois pour la même période de travail.',
        savePayoutSms: 'Enregistrer le SMS de versement',
        notificationsHeading: 'Notifications client par défaut',
        notificationsIntro: 'Valeurs du commerçant pour Quick Serve et les notifications automatiques de commande prête. Les stations peuvent les remplacer dans les paramètres avancés du POS ; utilisez la réinitialisation pour effacer toutes les exceptions de station.',
        quickServeToggle: 'Activer le flux Quick Serve par défaut',
        quickServeHelp: 'Lorsqu’il est activé, les nouvelles stations héritent de Quick Serve paiement d’abord, sauf exception. Les stations en mode Lot (Bar) n’utilisent jamais Quick Serve.',
        autoSmsToggle: 'Envoyer un SMS automatiquement lorsque la commande est prête',
        autoSmsHelp: 'Envoie un SMS automatiquement lorsque le KDS marque la commande comme terminée, si l’addition a un numéro de téléphone.',
        autoEmailToggle: 'Envoyer un e-mail automatiquement lorsque la commande est prête',
        autoEmailHelp: 'Envoie un e-mail automatiquement lorsque le KDS marque la commande comme terminée, si l’addition a une adresse e-mail.',
        defaultMessageLabel: 'Message par défaut « commande prête »',
        defaultMessageHelp: 'Utilisé pour les SMS et e-mails automatiques lorsqu’une station n’a pas son propre message.',
        saveNotifications: 'Enregistrer les notifications par défaut',
        resetStations: 'Réinitialiser les exceptions de toutes les stations',
        workPeriodHeading: 'Maintenance des périodes de travail',
        workPeriodIntro: 'Réconcilier les périodes terminées pour sortir les utilisateurs encore marqués actifs après la fin de leur période. Les périodes ouvertes ne sont pas concernées.',
        workPeriodHelp: 'La réconciliation n’envoie pas automatiquement les rapports de service.',
        reconcile: 'Réconcilier les périodes de travail terminées',
        reconcileTitle: 'Réconcilier les périodes de travail terminées',
        reconcileBody: 'Cela sortira les utilisateurs encore marqués actifs dans des périodes déjà terminées, en utilisant l’heure de fin de cette période.',
        reconcileHelp: 'Les périodes ouvertes ne seront pas concernées. Les utilisateurs déjà sortis ne seront pas modifiés.',
        reconciling: 'Réconciliation…',
        resetTitle: 'Réinitialiser les exceptions de notification des stations',
        resetBody: 'Cela efface les exceptions Quick Serve et de notification automatique sur toutes les stations de ce commerçant. Les stations hériteront de ces valeurs par défaut.',
        resetHelp: 'Les messages « commande prête » propres à chaque station seront également effacés.',
        resetting: 'Réinitialisation…',
        resetConfirm: 'Réinitialiser toutes les stations',
    },
    productEdit: {
        details: 'Détails du produit',
        productAlt: 'Produit',
        change: 'Modifier',
        addImage: 'Ajouter une image',
        name: 'Nom du produit',
        price: 'Prix (en $)',
        cardFee: 'Options de frais de carte',
        sku: 'SKU',
        internalOnly: 'Article interne uniquement',
        internalInherited: 'Cet article hérite d’Article interne uniquement de sa catégorie. Déplacez-le vers une autre catégorie pour le synchroniser avec les boutiques en ligne.',
        internalHelp: 'Conservez-le uniquement sur le POS et BistroAdmin. Il ne sera pas synchronisé avec les boutiques en ligne ni d’autres canaux.',
        taxRate: 'Taux de taxe %',
        stripeTax: 'Catégorie fiscale Stripe',
        inheritDefault: 'Hériter la valeur par défaut ({code})',
        food: 'Aliments ({code})',
        alcohol: 'Alcool ({code})',
        merchandise: 'Marchandise ({code})',
        custom: 'Personnalisé ({code})',
        description: 'Description du produit',
        saveDetails: 'Enregistrer les détails du produit',
        addVariations: 'Ajouter des variantes',
        variation: 'Variante',
        priceShort: 'Prix',
        stock: 'Stock',
        onHand: 'En stock',
        addAnotherVariation: 'Ajouter une autre variante',
        addOptions: 'Ajouter des options',
        option: 'Option',
        fromCategory: 'De la catégorie',
        fromCategoryTitle: 'Appliqué depuis le modèle de catégorie',
        trackStock: 'Suivre le stock',
        on: 'Oui',
        off: 'Non',
        remove: 'Retirer',
        addAnotherOption: 'Ajouter une autre option',
        manageInventory: 'Gérer l’inventaire',
        totalStock: 'Stock total (somme des variantes) :',
        variationStockHelp: 'Modifiez le stock sur chaque ligne de variante. L’inventaire parent n’est pas utilisé tant que des variantes existent.',
        availableStock: 'Stock disponible',
        saveInventory: 'Enregistrer l’inventaire',
    },
    stripe: {
        heading: 'Paiements de pourboires Stripe',
        connected: 'Connecté',
        pending: 'Inscription en attente',
        restricted: 'Restreint',
        disabled: 'Désactivé',
        notConnected: 'Non connecté',
        linkedExisting: 'Compte existant lié',
        platformCreated: 'Compte créé sur la plateforme',
        enterAccountId: 'Saisissez un ID de compte Stripe à lier.',
        acctPrefix: "Les ID de compte Stripe doivent commencer par 'acct_'.",
        disabledHelp: 'Les paiements de pourboires sont désactivés dans les paramètres du magasin. Activez un mode de routage avant d’envoyer des liens ou de lier des comptes Stripe.',
        chooseHow: 'Choisissez comment connecter cet employé pour les pourboires :',
        createNew: 'Créer',
        linkExisting: 'Lier un existant',
        sendOnboard: 'Envoyer un lien d’inscription pour créer un compte Stripe :',
        sendTo: 'Envoyer à {dest}',
        noEmail: 'Aucun e-mail',
        noPhone: 'Aucun téléphone',
        emailLink: 'Lien par e-mail',
        textLink: 'Lien par SMS',
        addContact: 'Ajoutez un e-mail ou un téléphone pour envoyer le lien d’inscription.',
        linkExistingHelp: 'Liez un compte Stripe connecté déjà présent sur cette plateforme.',
        linkAccount: 'Lier le compte Stripe',
        disabledOnboard: 'Les paiements de pourboires sont désactivés dans les paramètres du magasin ; les liens d’inscription sont indisponibles.',
        resend: 'Renvoyer le lien d’inscription :',
        email: 'E-mail',
        text: 'SMS',
        refresh: 'Actualiser',
        removeConfirm: 'Retirer ce compte Stripe ? L’employé devra être configuré à nouveau pour recevoir des pourboires.',
        removeAccount: 'Retirer le compte Stripe',
        incomplete: 'L’inscription Stripe est incomplète. L’employé doit terminer la configuration pour recevoir des pourboires.',
        autoPayout: 'Paiement auto des pourboires :',
        enabled: 'Activé',
        disabledBtn: 'Désactivé',
        viewDashboard: 'Voir le tableau de bord Stripe',
        disconnect: 'Déconnecter',
        restrictedHelp: 'Le compte Stripe a des restrictions. L’utilisateur doit mettre à jour ses informations sur Stripe.',
        fixOnStripe: 'Corriger sur Stripe',
    },
    toast: {
        exportedJson: '{products} produits et {categories} catégories exportés (JSON)',
        exportedExcel: '{products} produits et {categories} catégories exportés (Excel)',
        invalidFile: 'Fichier invalide : {errors}',
        parseJson: 'Impossible de lire le fichier. Sélectionnez un export JSON valide.',
        parseExcel: 'Impossible de lire le fichier Excel : {message}',
        importStarting: 'Démarrage de l’import…',
        catsCreated: '{count} catégories créées',
        catsExisted: '{count} catégories existaient déjà',
        prodsCreated: '{count} produits créés',
        varsCreated: '{count} variantes créées',
        optsCreated: '{count} options créées',
        imagesFailed: '{count} images n’ont pas pu être transférées',
        importIssues: 'Import terminé avec des problèmes : {summary}. {errors} erreur(s).',
        importComplete: 'Import terminé ! {summary}',
        importFailed: 'Échec de l’import : {message}',
        noExportData: 'Aucune donnée à exporter pour cette période.',
        reportDownloaded: 'Rapport de ventes téléchargé ({format}).',
        exportFailed: 'Échec de l’export du rapport de ventes.',
        addEmail: 'Ajoutez un e-mail sur le profil de l’employé pour envoyer des rapports.',
        addPhone: 'Ajoutez un téléphone sur le profil de l’employé pour envoyer des rapports.',
        reportSentEmail: 'Rapport de vacation envoyé à {dest}',
        reportSentPhone: 'Rapport de vacation envoyé à {dest}',
        reportFailed: 'Échec de l’envoi du rapport de vacation.',
        photoFailed: 'Impossible d’utiliser cette photo. Réessayez avec une image plus petite.',
    },
    payoutActions: {
        payOutTips: 'Payer les pourboires',
        paying: 'Paiement…',
        markPaid: 'Marquer comme payé (manuel)',
        markingPaid: 'Marquage comme payé…',
        markPaidSkip: 'Marquer comme payé (ignorer)',
        confirmPooled: 'Confirmer le paiement mis en commun',
        payPooled: 'Payer la part mise en commun',
        payingPooled: 'Paiement de la part mise en commun…',
        retryFailed: 'Réessayer les virements échoués',
        retryingFailed: 'Nouvel essai des virements échoués…',
        processing: 'Traitement…',
        reclaimPlatform: 'Récupération vers la plateforme…',
        reclaimTransfer: 'Récupération et transfert…',
        tryNow: 'Essayer maintenant',
        trying: 'Essai…',
        emailSetup: 'Lien d’inscription par e-mail',
        textSetup: 'Lien d’inscription par SMS',
        pendingTransfers: 'Certains virements de cette période sont encore en attente.',
        platformLiquidity: 'Liquidité des pourboires sur la plateforme',
        loadingBalances: 'Chargement des soldes de la plateforme…',
        available: 'Disponible',
        pending: 'En attente',
        openObligations: 'Obligations ouvertes',
        netExposure: 'Exposition nette',
        netPosition: 'Position nette',
        held: 'Retenu',
        pooledShareStatus: 'Statut de la part mise en commun',
        poolShare: 'Part du pool',
        payableNow: 'Payable maintenant',
        availableTips: 'Pourboires et gratifications disponibles',
        availablePayout: 'Disponible pour paiement',
        paidToManager: 'Pourboires et gratifications versés au manager',
        tipRoutingMode: 'Mode de routage des pourboires',
        designatedRecipient: 'Destinataire désigné des pourboires',
        tipsOverview: 'Aperçu des pourboires',
        payoutSuccessful: 'Paiement réussi',
        payoutId: 'ID de paiement',
        payoutAmount: 'Montant du paiement',
        payoutMethod: 'Méthode de paiement',
    },
    customerScreen: {
        note: 'Note :',
        noteBody: 'Les images, URL et vidéos enregistrées ici sont disponibles pour l’écran client. Les stations choisissent quels éléments afficher.',
        websiteUrl: 'URL du site',
        websiteName: 'Nom du site',
        saveUrl: 'Enregistrer l’URL',
        url: 'URL',
        deleteUrl: 'Supprimer l’URL ?',
        deleteUrlNamed: 'Supprimer « {name} » ? Cette action est irréversible.',
        deleteUrlBody: 'Supprimer cette URL ? Cette action est irréversible.',
        imageName: 'Nom de l’image',
        saveImage: 'Enregistrer l’image',
        deleteImage: 'Supprimer l’image ?',
        deleteImageNamed: 'Supprimer « {name} » ? Cette action est irréversible.',
        deleteImageBody: 'Supprimer cette image ? Cette action est irréversible.',
        videoName: 'Nom de la vidéo',
        saveVideo: 'Enregistrer la vidéo',
        deleteVideo: 'Supprimer la vidéo ?',
        deleteVideoNamed: 'Supprimer « {name} » ? Cette action est irréversible.',
        deleteVideoBody: 'Supprimer cette vidéo ? Cette action est irréversible.',
        images: 'Images',
        imagesIntro: 'Images disponibles pour l’écran client.',
        replaceImage: 'Remplacer l’image',
        chooseImage: 'Choisir une image',
        editImageName: 'Modifier le nom de l’image',
        websites: 'Sites web',
        websitesIntro: 'URL de sites disponibles pour l’écran client.',
        videos: 'Vidéos',
        videosIntro: 'Vidéos disponibles pour l’écran client.',
        replaceVideo: 'Remplacer la vidéo',
        chooseVideo: 'Choisir une vidéo',
        editVideoName: 'Modifier le nom de la vidéo',
        editUrl: 'Modifier l’URL',
        urls: 'URL',
        urlsIntro: 'Pages web disponibles pour l’écran client.',
        editWebsite: 'Modifier le site',
        replacePoster: 'Remplacer l’affiche',
        choosePoster: 'Choisir une affiche',
        poster: 'Affiche',
        mp4Only: 'Fichiers MP4 uniquement.',
    },
    layouts: {
        title: 'Plans',
        venuesHeader: 'Salles et plans',
        venuesIntro: 'Plans de salle disponibles pour les stations.',
        newVenue: 'Nouvelle salle',
        noVenues: 'Aucune salle pour l’instant. Créez-en une pour commencer — chaque salle peut contenir plusieurs plans que les stations POS peuvent utiliser en mode plan.',
        stationHeader: 'Mode plan de la station',
        stationIntro: 'Activez la vue plan par station.',
        noStations: 'Aucune station configurée.',
        layoutOn: 'Mode plan ACTIVÉ',
        layoutOff: 'Mode plan DÉSACTIVÉ',
        venueOption: '— Salle —',
        layoutOption: '— Plan —',
        note: 'Note :',
        noteBody: 'Lorsque le mode plan est activé, cette station ouvre le plan sélectionné au lieu de la grille de produits. Les opérateurs peuvent aussi le basculer sur l’appareil.',
        inactive: 'inactif',
        showLayouts: 'Afficher les plans',
        noLayouts: 'Aucun plan pour l’instant.',
        noLayoutsForVenue: 'Aucun plan actif pour ce lieu. Créez-en un sous Lieux et plans.',
        layoutAssigned: 'Plan attribué',
        pickVenueLayout: 'Choisissez un lieu et un plan avant d’activer le mode plan.',
        layoutLoading: 'L’affectation du plan est encore en cours de chargement. Réessayez dans un instant.',
        layoutSaveFailed: 'La station a été mise à jour, mais l’enregistrement du plan a échoué. Réessayez.',
        saveLayoutBinding: 'Enregistrer le plan',
        newLayout: 'Nouveau plan',
        deactivate: 'Désactiver',
        editVenue: 'Modifier la salle',
        description: 'Description',
        eventVenueId: 'Id de salle d’événement (lien optionnel)',
        eventVenuePlaceholder: 'Laissez vide si vous ne liez pas à une salle d’événement Rebelity',
        editLayout: 'Modifier le plan',
        newLayoutTitle: 'Nouveau plan',
        nameRequired: 'Nom *',
        importFromEventVenue: 'Importer depuis la salle d’événement',
        importFromEventVenueHelp: 'Copie un plan d’assise billetterie vers un nouveau plan POS (visuel uniquement — pas de sync billets).',
        importIntro: 'Crée un nouveau plan POS à partir de la couche d’assise liée. Copie visuelle ponctuelle. Les ObjectId billets ne deviennent pas des ids de table POS. Les liaisons de station ne changent pas.',
        importSeatingLayer: 'Couche d’assise',
        importLayoutName: 'Nom du nouveau plan',
        importDefault: 'par défaut',
        importNoSeatings: 'Aucune couche d’assise active pour cet Id de salle d’événement.',
        importPreview: 'Aperçu',
        importPreviewing: 'Aperçu…',
        importPreviewFailed: 'Échec de l’aperçu. Les plans POS existants n’ont pas été modifiés.',
        importEmptyMap: 'Rien de convertible. L’enregistrement est bloqué pour éviter d’effacer un plan.',
        importCreate: 'Créer le plan',
        importCommitting: 'Import…',
        importCommitFailed: 'Échec de l’import. Les plans POS existants n’ont pas été modifiés.',
        importMapped: 'Convertis',
        importSkipped: 'Ignorés',
        importConverter: 'Convertisseur',
        importSkipReason: 'Ignoré {otype} (non pris en charge sur POS)',
    },
    integrations: {
        shopify: 'Shopify',
        shopifyIntro: 'Synchronisez le stock avec votre boutique en ligne. Les catégories et produits internes uniquement ne sont jamais inclus.',
        shopifyIntegration: 'Intégration Shopify',
        syncOn: 'Sync activée',
        syncPaused: 'Sync en pause',
        connectedDomain: 'Connecté · {domain}',
        location: 'Emplacement',
        mappedSkus: 'SKU associés',
        lastReconcile: 'Dernier rapprochement',
        openConflicts: 'Conflits ouverts',
        failedJobs: 'Tâches de sync échouées',
        lastCatalog: 'Dernière sync catalogue',
        shopifyLocation: 'Emplacement Shopify',
        selectLocation: 'Sélectionner un emplacement',
        skuMatch: 'Correspondance SKU',
        matched: 'Correspondants',
        unmatched: 'Sans correspondance',
        unmatchedCollapsed: '{count} articles Bistro sont masqués. Développez pour les lier.',
        excluded: 'Exclus (interne uniquement)',
        linkHelp: 'Liez un article Bistro à une variante Shopify non liée lorsque les SKU ne correspondent pas. La liaison ne copie pas la quantité.',
        conflicts: 'Conflits d’inventaire',
        initialFill: 'Remplissage initial',
        fillHelp: 'Copiez la quantité en stock une fois, puis gardez les deux systèmes synchronisés via les ventes et modifications. Si les deux vendent, les décréments sont fusionnés. Un réglage explicite utilise la modification la plus récente ; si les heures correspondent, la quantité la plus basse l’emporte.',
        fillOnlineToBistro: 'Boutique en ligne → Bistro (recommandé)',
        fillBistroToOnline: 'Bistro → boutique en ligne',
        fillMatchOnly: 'Correspondance seulement — ne pas encore copier les quantités',
        enableSync: 'Activer la sync d’inventaire',
        copyOnlineToBistro: 'Copier boutique en ligne → Bistro',
        copyBistroToOnline: 'Copier Bistro → boutique en ligne',
        pauseSync: 'Mettre la sync en pause',
        catalog: 'Catalogue (nom, prix, image)',
        catalogHelp: 'Crée les produits non liés dans les deux sens, puis copie le nom, le prix et l’image des articles déjà liés. L’import et Copier le catalogue boutique → Bistro créent des produits Bistro depuis Shopify (aucun lien préalable). Copier le catalogue Bistro → boutique crée des produits Shopify depuis les SKU Bistro non liés. Les variantes et options synchronisent nom et prix ; les images s’appliquent au produit parent.',
        importCatalog: 'Importer le catalogue depuis Shopify',
        importHelp: 'Crée des produits Bistro à partir des produits Shopify actifs qui ont un SKU, ou lie ces SKU s’ils existent déjà dans Bistro. Chaque produit va dans une catégorie Bistro nommée d’après le type de produit Shopify (créée si besoin ; type vide = réserve ci-dessous). Les articles déjà liés sont re-catégorisés de la même façon. Le suivi d’inventaire est activé pour les imports, y compris à quantité 0. Les quantités disponibles de l’emplacement sélectionné sont copiées dans Bistro. Les nouvelles catégories sont ajoutées au menu POS par défaut. Cela n’active pas la sync d’inventaire en continu.',
        importScope: 'Portée de l’import',
        importScopeAll: 'Tous les emplacements (catalogue entier)',
        importScopeLocation: 'Emplacement sélectionné',
        importScopeHelp: 'Tous importe chaque produit Shopify actif avec SKU. Choisir un emplacement n’importe que les variantes stockées dans ce magasin (niveau d’inventaire présent ; la quantité peut être 0).',
        importScopeSummary: 'Portée : {scope}',
        importSummary: '{shopify} produits Shopify · à créer {create} · {variations} variations · lier {link} · ignorer {skip}',
        importCategory: 'Catégorie Bistro de secours (si le type de produit Shopify est vide)',
        importCategoryDefault: 'Shopify (créer si besoin)',
        importCategoryCreate: 'Aucune catégorie. Les types de produit vides utiliseront une catégorie Shopify.',
        importSimple: 'Créer le produit',
        importVariations: 'Créer le produit + {count} variations',
        importLink: 'Lier {count} SKU existant(s)',
        importNow: 'Importer le catalogue',
        currencyTitle: 'Devise du catalogue',
        currencySummary: 'Boutique Shopify : {shop} · Compte Bistro : {account}',
        currencyUnknown: 'inconnue',
        fxRate: 'Taux de change Bistro',
        fxRatePlaceholder: 'ex. 1,27',
        fxRateHelp: 'Combien de {account} valent 1 {shop}. L’import multiplie les prix Shopify par ce taux ; l’export divise.',
        fxRateSave: 'Enregistrer le taux',
        fxRateSaved: 'Taux de change Bistro enregistré.',
        fxRateInvalid: 'Saisissez un taux supérieur à zéro.',
        fxRateSaveFailed: 'Impossible d’enregistrer le taux de change Bistro.',
        fxRateRequired: 'Saisissez et enregistrez un taux de change Bistro avant d’importer ou de copier les prix du catalogue.',
        fxCurrencyUnknown: 'Devise de la boutique non détectée. Ouvrez l’aperçu d’import ou reconnectez Shopify avant de copier les prix.',
        fxNotRequired: 'Aucune conversion nécessaire — les devises correspondent.',
        disconnectShopify: 'Déconnecter Shopify',
        connectShopify: 'Connecter Shopify',
        connecting: 'Connexion…',
        helpAria: 'Comment connecter Shopify et importer le catalogue',
        helpHint: 'Besoin d’aide ? Cliquez sur ? pour les étapes simples de connexion et d’import.',
        helpTitle: 'Connecter Shopify et importer le catalogue',
        helpClose: 'Fermer l’aide',
        helpConnectTitle: 'Connectez votre boutique',
        helpConnect1: 'Dans Shopify, allez dans Paramètres → Applications et canaux de vente → Développer des applications et créez une application personnalisée.',
        helpConnect2: 'Activez l’accès API Admin pour les produits, l’inventaire et les emplacements (lecture et écriture si proposé). N’ajoutez pas les scopes webhook.',
        helpConnect3: 'Copiez l’URL de redirection autorisée ci-dessous et collez-la dans l’application Shopify. Puis installez l’application.',
        helpConnect4: 'Collez l’ID client, le secret client et le domaine de la boutique (votre-boutique.myshopify.com).',
        helpConnect5: 'Cliquez sur Enregistrer les identifiants, puis Connecter Shopify.',
        helpConnect6: 'Une fois de retour ici, choisissez l’emplacement Shopify qui détient le stock.',
        helpImportTitle: 'Importez le catalogue',
        helpImport1: 'Choisissez l’emplacement Shopify qui détient le stock. La catégorie de secours ne sert que si un produit Shopify n’a pas de type de produit.',
        helpImport2: 'Cliquez sur Importer le catalogue. Les produits Shopify actifs avec SKU sont créés ou liés dans Bistro selon le type de produit (catégories créées si besoin). Les articles déjà liés sont re-catégorisés. Les quantités sont copiées et le suivi d’inventaire est activé.',
        helpImport3: 'Les produits importés et les nouvelles catégories sont ajoutés au menu POS par défaut (souvent ALL) pour apparaître à la caisse.',
        helpImport4: 'Quand vous voulez que les quantités restent synchronisées en continu, cliquez sur Activer la sync d’inventaire. Pour créer des produits Shopify depuis des articles Bistro non liés, utilisez Copier le catalogue Bistro → boutique en ligne.',
        helpTipsTitle: 'À retenir',
        helpTip1: 'Chaque produit a besoin d’un SKU.',
        helpTip2: 'Les brouillons et les articles sans SKU sont ignorés.',
        helpTip3: 'L’import copie le stock disponible de l’emplacement sélectionné et active le suivi ; il n’active pas la sync d’inventaire en continu.',
        helpTip4: 'Les SKU déjà présents dans Bistro sont liés et re-catégorisés selon le type de produit Shopify, pas dupliqués.',
        check: 'Check',
        checkIntro: 'Paie intégrée pour cet emplacement. La connexion crée une entreprise Check ; le signataire autorisé termine Check Onboard (banque, EIN et autorisation).',
        checkIntegration: 'Intégration Check',
        connectCheck: 'Connecter Check',
        employees: 'Employés',
        disconnectConfirm: 'Déconnecter Shopify ? L’inventaire ne sera plus synchronisé. L’ID client et le secret sont conservés.',
    },
};

export default fr;
